// Problem / Service categories — shown prominently for quick WhatsApp booking.
export const SERVICES = [
  {
    id: "love-separation",
    icon: "HeartHandshake",
    color: "#B4232A",
    title_en: "Love & Relationship / Separation",
    title_bn: "প্রেম ও সম্পর্ক / বিচ্ছেদ",
    title_hi: "प्रेम व रिश्ते / अलगाव",
    desc_en: "Guidance for love difficulties, misunderstandings, separation and emotional distress within relationships.",
    desc_bn: "প্রেমের সমস্যা, ভুল বোঝাবুঝি, বিচ্ছেদ ও সম্পর্কের মানসিক কষ্টের জন্য পরামর্শ।",
    desc_hi: "प्रेम कठिनाइयों, गलतफहमी, अलगाव व रिश्तों की भावनात्मक पीड़ा के लिए मार्गदर्शन।",
  },
  {
    id: "marriage-problems",
    icon: "Sparkles",
    color: "#0E5A5E",
    title_en: "Marriage & Kundali Concerns",
    title_bn: "বিবাহ ও কুণ্ডলী সমস্যা",
    title_hi: "विवाह व कुंडली बाधा",
    desc_en: "Delays in marriage, family harmony, matchmaking questions and kundali-related concerns.",
    desc_bn: "বিবাহে বিলম্ব, পারিবারিক সম্প্রীতি ও কুণ্ডলী সম্পর্কিত বিষয়।",
    desc_hi: "विवाह में विलंब, पारिवारिक सामंजस्य व कुंडली संबंधी चिंताएँ।",
  },
  {
    id: "enemy-protection",
    icon: "ShieldAlert",
    color: "#8E1B22",
    title_en: "Enemy Concerns & Protection",
    title_bn: "শত্রু সমস্যা ও সুরক্ষা",
    title_hi: "शत्रु बाधा व रक्षा",
    desc_en: "Traditional protective practices for conflict, negative influence and repeated obstacles.",
    desc_bn: "সংঘাত, নেতিবাচক প্রভাব ও বারবার বাধার জন্য ঐতিহ্যবাহী সুরক্ষা অনুশীলন।",
    desc_hi: "संघर्ष, नकारात्मक प्रभाव व बार-बार आने वाली बाधाओं हेतु पारंपरिक रक्षा अभ्यास।",
  },
  {
    id: "childbirth-santan",
    icon: "Baby",
    color: "#1B7F84",
    title_en: "Childbirth & Santan Prapti",
    title_bn: "সন্তান প্রাপ্তি",
    title_hi: "संतान प्राप्ति",
    desc_en: "Devotional prayers and family concerns around children. Not a substitute for medical care.",
    desc_bn: "সন্তান সম্পর্কিত ভক্তিমূলক প্রার্থনা ও পারিবারিক বিষয়। চিকিৎসার বিকল্প নয়।",
    desc_hi: "संतान संबंधी भक्तिमय प्रार्थना व पारिवारिक चिंताएँ। चिकित्सा का विकल्प नहीं।",
  },
  {
    id: "career-finance",
    icon: "TrendingUp",
    color: "#4B4A6B",
    title_en: "Career, Business & Finance",
    title_bn: "কর্মজীবন, ব্যবসা ও অর্থ",
    title_hi: "करियर, व्यापार व धन",
    desc_en: "Guidance for career uncertainty, business concerns, financial difficulty and repeated obstacles.",
    desc_bn: "কর্মজীবনের অনিশ্চয়তা, ব্যবসা, আর্থিক সমস্যা ও বাধার জন্য পরামর্শ।",
    desc_hi: "करियर अनिश्चितता, व्यापार, वित्तीय कठिनाई व बाधाओं हेतु मार्गदर्शन।",
  },
  {
    id: "tantra-remedies",
    icon: "Flame",
    color: "#A83252",
    title_en: "Maa Tara Tantra Remedies",
    title_bn: "মা তারা তন্ত্র প্রতিকার",
    title_hi: "माँ तारा तंत्र उपाय",
    desc_en: "Authentic Shakta-Tantric remedies rooted in the tradition of Tarapith for obstacles and spiritual protection.",
    desc_bn: "তারাপীঠের ঐতিহ্যভিত্তিক প্রামাণিক শাক্ত-তান্ত্রিক প্রতিকার — বাধা ও আধ্যাত্মিক সুরক্ষার জন্য।",
    desc_hi: "तारापीठ परंपरा पर आधारित प्रामाणिक शाक्त-तांत्रिक उपाय — बाधा व आध्यात्मिक रक्षा हेतु।",
  },
  {
    id: "maa-tara-puja",
    icon: "Sun",
    color: "#073E42",
    featured: true,
    title_en: "Maa Tara Special Puja & Havan",
    title_bn: "মা তারা বিশেষ পূজা ও যজ্ঞ",
    title_hi: "माँ तारा विशेष पूजा व हवन",
    desc_en: "Book special Tarapith temple puja, havan and devotional rituals performed with tradition and care.",
    desc_bn: "ঐতিহ্য ও যত্নসহকারে সম্পন্ন তারাপীঠ মন্দিরের বিশেষ পূজা, যজ্ঞ ও ভক্তিমূলক অনুষ্ঠান বুক করুন।",
    desc_hi: "परंपरा व श्रद्धा के साथ संपन्न तारापीठ मंदिर की विशेष पूजा, हवन व अनुष्ठान बुक करें।",
  },
  {
    id: "kundali-reading",
    icon: "Orbit",
    color: "#C2410C",
    title_en: "Kundali & Horoscope Reading",
    title_bn: "কুণ্ডলী ও রাশিফল বিশ্লেষণ",
    title_hi: "कुंडली व राशिफल विश्लेषण",
    desc_en: "A detailed Vedic chart reading — planetary periods, strengths, timing of events and practical remedial guidance.",
    desc_bn: "বিস্তারিত বৈদিক কুণ্ডলী বিশ্লেষণ — গ্রহদশা, শক্তি, সময়কাল ও ব্যবহারিক প্রতিকারের পরামর্শ।",
    desc_hi: "विस्तृत वैदिक कुंडली विश्लेषण — ग्रह दशा, बल, समय-निर्धारण व व्यावहारिक उपाय।",
  },
  {
    id: "kundali-milan",
    icon: "Link2",
    color: "#B4232A",
    title_en: "Kundali Milan — Match Making",
    title_bn: "কুণ্ডলী মিলন — বিবাহ বিচার",
    title_hi: "कुंडली मिलान — विवाह विचार",
    desc_en: "Traditional guna-milan and compatibility study for marriage proposals, with clear, respectful interpretation.",
    desc_bn: "বিবাহ প্রস্তাবের জন্য ঐতিহ্যবাহী গুণ-মিলন ও সামঞ্জস্য বিচার, স্পষ্ট ও শ্রদ্ধাশীল ব্যাখ্যাসহ।",
    desc_hi: "विवाह प्रस्ताव हेतु पारंपरिक गुण-मिलान व सामंजस्य विचार, स्पष्ट व सम्मानजनक व्याख्या सहित।",
  },
  {
    id: "grah-shanti",
    icon: "Sparkle",
    color: "#0E5A5E",
    title_en: "Grah Shanti — Kaal Sarp, Pitra & Mangal Dosh",
    title_bn: "গ্রহ শান্তি — কালসর্প, পিতৃ ও মঙ্গল দোষ",
    title_hi: "ग्रह शांति — कालसर्प, पितृ व मंगल दोष",
    desc_en: "Shanti puja and traditional remedial rites for Kaal Sarp, Pitra Dosh, Mangal Dosh and Shani-related concerns.",
    desc_bn: "কালসর্প, পিতৃদোষ, মঙ্গলদোষ ও শনি সংক্রান্ত বিষয়ের জন্য শান্তি পূজা ও ঐতিহ্যবাহী প্রতিকার।",
    desc_hi: "कालसर्प, पितृ दोष, मंगल दोष व शनि संबंधी विषयों हेतु शांति पूजा व पारंपरिक उपाय।",
  },
  {
    id: "amavasya-puja",
    icon: "Moon",
    color: "#8E1B22",
    title_en: "Amavasya & Kaushiki Amavasya Puja",
    title_bn: "অমাবস্যা ও কৌশিকী অমাবস্যা পূজা",
    title_hi: "अमावस्या व कौशिकी अमावस्या पूजा",
    desc_en: "Reserve your sankalp for the new-moon nights — including the great Kaushiki Amavasya night at Tarapith.",
    desc_bn: "অমাবস্যা রাতের জন্য সংকল্প সংরক্ষণ করুন — তারাপীঠের মহান কৌশিকী অমাবস্যা সহ।",
    desc_hi: "अमावस्या रात्रि हेतु संकल्प आरक्षित करें — तारापीठ की महान कौशिकी अमावस्या सहित।",
  },
  {
    id: "vastu",
    icon: "Home",
    color: "#1B7F84",
    title_en: "Vastu Guidance for Home & Business",
    title_bn: "বাস্তু পরামর্শ — গৃহ ও ব্যবসা",
    title_hi: "वास्तु मार्गदर्शन — गृह व व्यापार",
    desc_en: "Traditional Vastu review of your home, shop or office with simple, non-destructive corrective suggestions.",
    desc_bn: "আপনার গৃহ, দোকান বা অফিসের ঐতিহ্যবাহী বাস্তু বিচার এবং সহজ সংশোধনী পরামর্শ।",
    desc_hi: "आपके घर, दुकान या कार्यालय का पारंपरिक वास्तु विचार व सरल सुधारात्मक सुझाव।",
  },
  {
    id: "gemstone-rudraksha",
    icon: "Gem",
    color: "#4B4A6B",
    title_en: "Gemstone & Rudraksha Guidance",
    title_bn: "রত্ন ও রুদ্রাক্ষ পরামর্শ",
    title_hi: "रत्न व रुद्राक्ष परामर्श",
    desc_en: "Chart-based advice on suitable gemstones, rudraksha and their traditional method of wearing and energising.",
    desc_bn: "কুণ্ডলী অনুসারে উপযুক্ত রত্ন, রুদ্রাক্ষ ও তাদের ঐতিহ্যবাহী ধারণ পদ্ধতির পরামর্শ।",
    desc_hi: "कुंडली आधारित उपयुक्त रत्न, रुद्राक्ष व उनकी पारंपरिक धारण विधि का परामर्श।",
  },
  {
    id: "shraddha-pitra",
    icon: "Landmark",
    color: "#A83252",
    title_en: "Shraddha & Ancestral Rites",
    title_bn: "শ্রাদ্ধ ও পিতৃকার্য",
    title_hi: "श्राद्ध व पितृ कर्म",
    desc_en: "Tarpan, Shraddha and Pitra Paksha rites performed at Tarapith on behalf of your family with due procedure.",
    desc_bn: "আপনার পরিবারের পক্ষে তারাপীঠে যথাবিধি তর্পণ, শ্রাদ্ধ ও পিতৃপক্ষের কার্য।",
    desc_hi: "आपके परिवार की ओर से तारापीठ में विधिपूर्वक तर्पण, श्राद्ध व पितृ पक्ष कर्म।",
  },
  {
    id: "muhurat",
    icon: "CalendarCheck",
    color: "#073E42",
    title_en: "Muhurat — Auspicious Date Selection",
    title_bn: "মুহূর্ত — শুভ দিন নির্বাচন",
    title_hi: "मुहूर्त — शुभ तिथि चयन",
    desc_en: "Choosing auspicious timing for marriage, griha pravesh, business opening, naming and other ceremonies.",
    desc_bn: "বিবাহ, গৃহপ্রবেশ, ব্যবসা শুরু, নামকরণ ও অন্যান্য অনুষ্ঠানের শুভ সময় নির্বাচন।",
    desc_hi: "विवाह, गृह प्रवेश, व्यापार आरंभ, नामकरण व अन्य संस्कारों हेतु शुभ समय चयन।",
  },
  {
    id: "mantra-diksha",
    icon: "Sprout",
    color: "#C2410C",
    title_en: "Mantra Diksha & Sadhana Guidance",
    title_bn: "মন্ত্র দীক্ষা ও সাধনা পরামর্শ",
    title_hi: "मंत्र दीक्षा व साधना मार्गदर्शन",
    desc_en: "Guidance for sincere seekers on mantra practice, daily sadhana discipline and the Tarapith tradition of study.",
    desc_bn: "আন্তরিক সাধকদের জন্য মন্ত্র অনুশীলন, দৈনিক সাধনার নিয়ম ও তারাপীঠ ঐতিহ্যের পরামর্শ।",
    desc_hi: "निष्ठावान साधकों हेतु मंत्र अभ्यास, दैनिक साधना अनुशासन व तारापीठ परंपरा का मार्गदर्शन।",
  },
  {
    id: "prasad-seva",
    icon: "Gift",
    color: "#B4232A",
    title_en: "Puja on Your Behalf & Prasad Seva",
    title_bn: "আপনার পক্ষে পূজা ও প্রসাদ সেবা",
    title_hi: "आपकी ओर से पूजा व प्रसाद सेवा",
    desc_en: "Cannot travel to Tarapith? Your sankalp puja is performed in your name and prasad is arranged for you.",
    desc_bn: "তারাপীঠে আসতে পারছেন না? আপনার নামে সংকল্প পূজা সম্পন্ন হয় এবং প্রসাদের ব্যবস্থা করা হয়।",
    desc_hi: "तारापीठ आना संभव नहीं? आपके नाम से संकल्प पूजा संपन्न होती है व प्रसाद की व्यवस्था की जाती है।",
  },
];

export function getService(id) {
  return SERVICES.find((s) => s.id === id) || null;
}
